'use client';

import { RefObject, useEffect, useRef } from 'react';
import Rellax from 'rellax';

export type UseRellaxOptions<T extends HTMLElement> = {
    center?: boolean;
    horizontal?: boolean;
    round?: boolean;
    speed?: number;
    vertical?: boolean;
    wrapper?: RefObject<T>;
};

export function useRellax<T extends HTMLElement = HTMLElement>({
    center = false,
    horizontal = true,
    round = true,
    speed = -2,
    vertical = true,
    wrapper,
}: UseRellaxOptions<T> = {}) {
    const ref = useRef<T>(null);

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        const rellax = new Rellax(ref.current, {
            center,
            horizontal,
            round,
            speed,
            vertical,
            wrapper: wrapper?.current ?? undefined,
        });

        return () => {
            rellax.destroy();
        };
    }, [ref, center, horizontal, round, speed, vertical, wrapper]);

    return ref;
}
